module.exports = __webpack_public_path__ + "static/media/key-login.2ec9b7b9.png";